import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
    <path d="M0.607178 0.000396729V15.0004L12.3929 7.5004L0.607178 0.000396729Z" fill="currentColor" />
  </svg>
);
